import { selectDictRegionModel } from '@src/modules/dictionaries/store'
import { Combobox } from '@src/components'
import { REGISTER_COLUMNS } from '@src/constants'
import { RegisterColumn } from './RegisterColumn'

export class ChildbirthRegionColumn extends RegisterColumn {
  static type = REGISTER_COLUMNS.CHILDBIRTH_REGION

  constructor (store, settings) {
    const column = {
      header: {
        title: 'Субъект РФ рождения',
        component: Combobox,
        props: {
          allowClear: true,
          mode: 'multiple',
          options: selectDictRegionModel(store.getState()).payload.map(mo => ({
            label: mo.name,
            value: mo.item_code,
            title: mo.name,
          })),
        },
        defaultValue: [],
      },
      width: 300,
      dataIndex: 'childbirth_region_name',
      dataRender: childbirth_region_name => childbirth_region_name ? childbirth_region_name : '-',
      sort: true,
      nullSearch: true,
    }

    super(column, settings)
  }

  _requestArgs ({ filters, nullSearches }) {
    let requestArgs = []

    if (filters?.childbirth_region_code && filters?.childbirth_region_code.length) {
      requestArgs = [{ field: 'childbirth_region_code', value: filters.childbirth_region_code, operator: '=', invalid: false, cast: 'right-any' }]
    }

    if (nullSearches[this.type]) {
      requestArgs = [{ field: this.type, operator: '=', value: null, invalid: false }]
    }

    return {
      control: {
        filters: requestArgs,
      },
    }
  }
}
